// Shared helper to compute casting progress with per-part clamping.
// Returns totals (required, decided, fulfilled) and a 0-100 percent value.

const defaultRequiredKeys = ['required', 'required_number', 'requiredCount', 'number'];
const defaultAssignedKeys = ['decided', 'signed_count', 'decidedCount', 'assigned', 'assignedCount'];

const pickNumericValue = (row, keys = []) => {
  if (!row) return 0;
  for (const key of keys) {
    if (!key) continue;
    const raw = row[key];
    if (raw == null) continue;
    const num = Number(raw);
    if (!Number.isNaN(num)) return num;
  }
  return 0;
};

export function calculateCastingProgress(parts = [], options = {}) {
  const getRequired =
    typeof options.getRequired === 'function'
      ? options.getRequired
      : (part) =>
          pickNumericValue(part, [
            options.requiredKey,
            ...(options.requiredKeys || []),
            ...defaultRequiredKeys,
          ]);

  const getAssigned =
    typeof options.getAssigned === 'function'
      ? options.getAssigned
      : (part) =>
          pickNumericValue(part, [
            options.assignedKey,
            ...(options.assignedKeys || []),
            ...defaultAssignedKeys,
          ]);

  let requiredTotal = 0;
  let assignedTotal = 0;
  let fulfilledTotal = 0;

  (Array.isArray(parts) ? parts : []).forEach((part) => {
    const required = Math.max(0, Math.floor(getRequired(part) || 0));
    const assigned = Math.max(0, Math.floor(getAssigned(part) || 0));
    if (required > 0) {
      requiredTotal += required;
      fulfilledTotal += Math.min(required, assigned);
    } else if (assigned > 0) {
      // part without requirement still counts toward decided, but not fulfillment
      assignedTotal += assigned;
      return;
    }
    assignedTotal += assigned;
  });

  const percent =
    requiredTotal > 0
      ? Math.min(100, Math.round((fulfilledTotal / requiredTotal) * 100))
      : 0;

  return {
    required: requiredTotal,
    decided: assignedTotal,
    fulfilled: fulfilledTotal,
    percent,
  };
}
